



























































  import ChampFormulaire from '@/commun/components/champ-formulaire/champ-formulaire.vue';
  import { SectionFormulaire } from '@/commun/components/champ-formulaire/section-formulaire';
  import { TextArea } from '@/commun/components/champ-formulaire/text-area';
  import Vue, { PropType } from 'vue';
  import DemandeProgramme, {
    DemandeProgrammeTypeModification,
    IndicateursModificationProgramme,
  } from '@/domain/models/demande-programme';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import { DatePicker } from '@/commun/components/champ-formulaire/date-picker';
  import { SectionFormulaireProgramme } from '@/components/faculte/demandes/formulaires/programme/section-formulaire-programme';

  export default Vue.extend({
    name: 'SectionApprobation',
    components: {
      TextArea,
      SectionFormulaire,
      ChampFormulaire,
      Tooltip,
      DatePicker,
    },
    mixins: [SectionFormulaireProgramme],
    props: {
      value: {
        type: Object as PropType<DemandeProgramme>,
        required: true,
      },
      indicateursProgramme: {
        type: Object as PropType<IndicateursModificationProgramme>,
        required: true,
      },
    },
    data() {
      return {
        demandeCourante: {} as DemandeProgramme,
        validationDate: false,
        maximumCaracteresCourriel: 320,
        maximumCaracteresJustification: 3500,
        dateFacultaire: null,
        menuProgramme: false,
        menuFacultaire: false,
      };
    },
    computed: {
      champDateFacultaireObligatoire(): boolean | undefined {
        return (
          this.indicateursProgramme.admissionExigences ||
          this.indicateursProgramme.admissionSessions ||
          this.indicateursProgramme.admissionSuspension ||
          this.indicateursProgramme.composantesConcentrations ||
          this.indicateursProgramme.composantesMineures ||
          this.indicateursProgramme.nombreCreditsAugmentation ||
          this.indicateursProgramme.nombreCreditsReduction
        );
      },
      regleValidationDateFacultaire(): string {
        if (
          this.demandeCourante.typeModification ===
            DemandeProgrammeTypeModification.MAJEURE_EXISTANTE &&
          !this.champDateFacultaireObligatoire
        ) {
          return '';
        }
        return 'requis';
      },
    },
  });
